import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { changePassword } from '../services/api';

/**
 * 修改密码弹窗
 */
const ChangePasswordModal = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const result = await changePassword({
        old_password: values.old_password,
        new_password: values.new_password,
      });
      if (result.success) {
        message.success('密码修改成功，请重新登录');
        form.resetFields();
        onClose();
        // 密码修改后强制重新登录
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        message.error(result.message || '修改失败');
      }
    } catch (error) {
      if (error.response) {
        message.error(error.response.data.message || '修改失败');
      } else if (error.message) {
        // validateFields 失败不提示
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="修改密码"
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      confirmLoading={loading}
      okText="确认修改"
      cancelText="取消"
      okButtonProps={{ style: { background: '#1890ff', borderColor: '#1890ff' } }}
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          name="old_password"
          label="原密码"
          rules={[{ required: true, message: '请输入原密码' }]}
        >
          <Input.Password prefix={<LockOutlined style={{ color: '#1890ff' }} />} placeholder="请输入原密码" />
        </Form.Item>
        <Form.Item
          name="new_password"
          label="新密码"
          rules={[
            { required: true, message: '请输入新密码' },
            { min: 6, message: '密码至少 6 位' },
          ]}
        >
          <Input.Password prefix={<LockOutlined style={{ color: '#1890ff' }} />} placeholder="请输入新密码（至少 6 位）" />
        </Form.Item>
        <Form.Item
          name="confirm_password"
          label="确认新密码"
          dependencies={['new_password']}
          rules={[
            { required: true, message: '请确认新密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('两次输入的密码不一致'));
              },
            }),
          ]}
        >
          <Input.Password prefix={<LockOutlined style={{ color: '#1890ff' }} />} placeholder="请再次输入新密码" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
